module.exports = __webpack_public_path__ + "media/new-conversation-tone.ad08ff67.mp3";